<template>
    <div>
        <div id="networks" class="box">
            <network-manager
                :contact-id="contactId"
                context="profile"
                :networks="availableNetworks"
                :contact-networks="contactNetworks"
            />
        </div>
    </div>
</template>

<script>
    import NetworkManager from '../data-views/networks/partials/NetworkManager';
    import { AVAILABLE_NETWORKS } from '../../constants/networks';

    export default {

        /**
         * The component name
         *
         * @type {string}
         */
        name: 'ManageNetworksRouterView',

        /**
         * The child components
         *
         * @type {Object}
         */
        components: {
            NetworkManager,
        },

        /**
         * Data
         *
         * @type {function}
         */
        data(){
            return {
                errorMessage: null,
            };
        },

        computed: {
            contactId() {
                return this.$root.contact_id;
            },
            contactNetworks() {
                return this.$root.networks;
            },
            availableNetworks() {
                return AVAILABLE_NETWORKS;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-normal {
        margin-bottom: $g-spacing-5;
    }
</style>
